/**
 * Currency and number formatting utilities.
 */
/**
 * Formats an MSRP value for display.
 *
 * Converts values like "160.00" to "$160".
 * Returns "N/A" for null, undefined, or empty values.
 *
 * @param msrp - The MSRP value from the API (e.g., "160.00", "159.99")
 * @returns Formatted MSRP string (e.g., "$160", "$159")
 *
 * @remarks
 * Currently assumes all MSRP values should have decimals stripped.
 * This is based on the assumption that MSRP values are whole dollar amounts
 * and the API returns them with ".00" decimals.
 */
export function formatMsrp(msrp) {
    if (!msrp || msrp.trim() === '') {
        return 'N/A';
    }
    const numericValue = parseFloat(msrp.replace(/[^0-9.-]/g, ''));
    if (isNaN(numericValue)) {
        return 'N/A';
    }
    const wholeNumber = Math.trunc(numericValue);
    return `$${wholeNumber}`;
}
